import { defineStore } from 'pinia'
import { useFutureStore } from './future'

export const useOrderStore = defineStore('order', {
  state: () => ({
    params: {},
    tab: 'position',
    curTab: 'lm',
    current: false,
  }),
  getters: {
    code() {
      const future = useFutureStore()
      return this.current ? future.code : ''
    },
  },
  actions: {
  },
})
